import React, { FCC } from 'react';
import { IProgressIndicatorProps } from './types';

import './ProgressIndicator.scss';

/** The progress indicator.
 *  It may be determinate or indeterminate.
 */
export const ProgressIndicator: FCC<IProgressIndicatorProps> = (props) => {
  const className = props.progress !== undefined ? '' : 'indeterminate';
  return (
    <div
      qa-id={props['qa-id']}
      className={`hlc-progress ${className}`}
      style={props.progress !== undefined ? { backgroundSize: `${props.progress}%` } : {}}
    />
  );
};

export default ProgressIndicator;
